import moment from 'moment-timezone';
import _ from 'lodash';

export const CONTENT_REQUEST_TASK_TYPE = 'CONTENT_REQUEST';
export const MEDIA_TYPES = {
  PHOTO: 'PHOTO',
  VIDEO: 'VIDEO',
};

let nextContentRequestUiId = 0;

export function createEmptyContentRequest(overrides = {}) {
  nextContentRequestUiId += 1;

  return {
    id: null,
    // Client-only id for drag-and-drop keys and validation error maps (not sent to API).
    ui_id: `content-request-${nextContentRequestUiId}`,
    title: '',
    description: '',
    media_type: '',
    ...overrides,
  };
}

export function createEmptyTask(overrides = {}) {
  return {
    task_id: '',
    task_type: CONTENT_REQUEST_TASK_TYPE,
    title: '',
    description: '',
    targeting: {},
    launch_date: null,
    due_date: null,
    launched_by: null,
    content_requests: [],
    ...overrides,
  };
}

export function taskToAPI(task) {
  return {
    task_type: task.task_type || CONTENT_REQUEST_TASK_TYPE,
    title: task.title,
    description: task.description,
    targeting: task.targeting || {},
    launch_date: formatDateForAPI(task.launch_date),
    due_date: formatDateForAPI(task.due_date),
    launched_by: task.launched_by,
    // API contract uses task_items; form stays content_requests, bc this form is specific to content request types
    task_items: task.content_requests.map((contentRequest) => ({
      ...(contentRequest.id != null ? { id: contentRequest.id } : {}),
      title: contentRequest.title,
      description: contentRequest.description,
      media_type: contentRequest.media_type,
    })),
  };
}

export function taskFromAPI(task = {}) {
  // API contract uses task_items; form stays content_requests, bc this form is specific to content request types
  const contentRequests = task.task_items || [];

  return createEmptyTask({
    task_id: task.task_id || task.id || '',
    task_type: task.task_type || CONTENT_REQUEST_TASK_TYPE,
    title: task.title || '',
    description: task.description || '',
    targeting: task.targeting || {},
    launch_date: formatDateFromAPI(task.launch_date),
    due_date: formatDateFromAPI(task.due_date),
    launched_by: task.launched_by || null,
    content_requests: _.sortBy(contentRequests, ['index']).map(
      (contentRequest) =>
        createEmptyContentRequest({
          id: contentRequest.id ?? contentRequest.request_id ?? null,
          title: contentRequest.title || '',
          description: contentRequest.description || '',
          media_type: contentRequest.media_type || '',
        })
    ),
  });
}

function formatDateForAPI(value) {
  if (!value) return null;
  // We need to include the timezone offset to make sure the due_date is sent properly as CST
  return moment(value).format('YYYY-MM-DD HH:mm:ssZ');
}

function formatDateFromAPI(value) {
  if (!value) return null;
  return moment(value);
}
